<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title"><b>Contents</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="30%"/>
<col width="70%"/>
</colgroup>
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><a href="#/xhtml/05_Introduction"><i>Introduction</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><a href="#/xhtml/06_Acknowledgements"><i>Acknowledgements</i></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/07_Chapter01"><b>Chapter 1</b></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/07_Chapter01">The Formative Years of the Railway System</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/08_Chapter02"><b>Chapter 2</b></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/08_Chapter02">Railway Experiments of the 1870s and 1880s</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><b>Chapter 3</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Consolidation and ‘The Lull Before the Storm’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><b>Chapter 4</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">The System’s Finest Hour</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><b>Chapter 5</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">The Aftermath of the Armistice and a New Conflict</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="tocb"><span href="#/xhtml/12_Photo_Gallery" title="Link target outside of Sample"><i>Photo Gallery</i></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><b>Chapter 6</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Decline and Fall 1945–94</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><b>Chapter 7</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">Narrow-Gauge Locomotives 1871–1971</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><b>Chapter 8</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Standard-Gauge Locomotives 1875–1967</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><b>Chapter 9</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">Rolling Stock Used Within the Arsenal</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><b>Chapter 10</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Surviving Remains</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="tocb"><span href="#/xhtml/18_Appendix01" title="Link target outside of Sample"><i>Appendix I: Royal Arsenal Railway Officials 1905–55</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/19_Appendix02" title="Link target outside of Sample"><i>Appendix II: RAR Mechanical Engineering Department Details</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/20_Appendix03" title="Link target outside of Sample"><i>Appendix III: Lieutenant Colonel Hemming’s Comparison Tables for Operational Data before and during the First World War</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/21_Appendix04" title="Link target outside of Sample"><i>Appendix IV: Locomotives Bought or Hired during the First World War (standard-gauge)</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/22_Appendix05" title="Link target outside of Sample"><i>Appendix V: Locomotive Disposals during the First World War (standard-gauge)</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/23_Appendix06" title="Link target outside of Sample"><i>Appendix VI: Locomotive Statistics as at 4 August 1914 and 11 November 1918 (standard-gauge)</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/24_Appendix07" title="Link target outside of Sample"><i>Appendix VII: Details of the narrow-gauge Manning Wardle Locomotives for the Royal Arsenal</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/25_Appendix08" title="Link target outside of Sample"><i>Appendix VIII: Details of standard-gauge Manning Wardle locomotives Supplied to the Royal Arsenal</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/26_Appendix09" title="Link target outside of Sample"><i>Appendix IX: 18in-gauge Locomotive Histories</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/27_Appendix10" title="Link target outside of Sample"><i>Appendix X: Standard-gauge Locomotive Histories</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/28_Appendix11" title="Link target outside of Sample"><i>Appendix XI: 2ft-Gauge Locomotive Histories</i></span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?ea65c9f0